export default __webpack_public_path__ + "static/media/bukhara2.71938160.png";